import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import { SvgIconProps } from "@mui/material/SvgIcon";

interface InputWithValidationProps {
  label: string;
  error?: boolean; // Optional boolean prop for error state
  helperText?: string; // Optional helper text
  autoComplete?: string; // Optional helper text
  className?: string; // Optional CSS class name
  name?: string; // Optional name for the input
  id?: string; // Optional ID for the input
  prefix?: React.ReactNode; // Optional prefix component
  suffix?: React.ReactNode; // Optional suffix component
  icon?: React.ReactElement<SvgIconProps>; // Optional icon
  [key: string]: any; // Allow additional props (e.g., onChange, value)
}

const InputWithValidation: React.FC<InputWithValidationProps> = ({
  label,
  error = false,
  helperText = "",
  autoComplete = 'on',
  className,
  name,
  id,
  prefix,
  suffix,
  icon,
  ...props
}) => {
  return (
    <Box className={className}>
      <TextField
        label={label}
        error={error}
        helperText={error ? helperText : ""}
        autoComplete={autoComplete ? autoComplete : ""}
        name={name}
        id={id}
        InputProps={{
          startAdornment: prefix && (
            <InputAdornment position="start">{prefix}</InputAdornment>
          ),
          endAdornment: suffix && (
            <InputAdornment position="end">{suffix}</InputAdornment>
          ),
        }}
        {...props}
        InputLabelProps={{
          shrink: !!props.value || undefined, // Ensures label stays above when autofill is active
        }}
        className={`block w-full p-2 rounded-md transition duration-200 ease-in-out focus:outline-none ${
          error ? "border-red-500" : "border-gray-300"
        } focus:ring-2 focus:ring-blue-500`}
      />
      {icon && <Box mt={1}>{icon}</Box>}{" "}
      {/* Render icon below the TextField if provided */}
      {error && (
        <p className="mt-1 text-red-500 text-sm">{helperText}</p>
      )}{" "}
      {/* Display helper text */}
    </Box>
  );
};

export default InputWithValidation;
